var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ProductCard',{attrs:{"classname":"col-6 col-sm-6 col-md-4 col-lg-4 product-item","product":_vm.product}})}
var staticRenderFns = []

export { render, staticRenderFns }